const difference = (atom, options) => {
    const observe = (callback) => {
        let prev;
        let initialValueAssigned = false;
        const selector = (value) => {
            const p = prev;
            prev = value;
            return { previous: p, current: value };
        };
        return atom.observe((value) => {
            const diffWrappedValue = selector(value);
            if (options?.skipInitial && !initialValueAssigned) {
                initialValueAssigned = true;
                return;
            }
            return callback(diffWrappedValue);
        });
    };
    return {
        ...atom,
        observe,
    };
};
export default difference;
